import React from 'react';
import PropTypes from 'prop-types';

const Products = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='products-title'>{altText}</title>
      <path fill='currentColor' d='M12 1.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75ZM7 18.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H7Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M2.915 8.494A2.25 2.25 0 0 1 4.927 7.25h14.146a2.25 2.25 0 0 1 2.012 1.244l1.586 3.17A.75.75 0 0 1 22 12.75h-1.25v7.75a2.25 2.25 0 0 1-2.25 2.25h-13a2.25 2.25 0 0 1-2.25-2.25v-7.75H2a.75.75 0 0 1-.67-1.085l1.585-3.171ZM19.25 12.75H14a.75.75 0 0 1-.67-.415L12 9.677l-1.33 2.658a.75.75 0 0 1-.67.415H4.75v7.75c0 .414.336.75.75.75h13a.75.75 0 0 0 .75-.75v-7.75Zm-6.037-4 1.25 2.5h6.324l-1.043-2.085a.75.75 0 0 0-.671-.415h-5.86Zm-8.286 0h5.86l-1.25 2.5H3.213l1.042-2.085a.75.75 0 0 1 .671-.415Z' clipRule='evenodd'/>
      <path fill='currentColor' d='M6.53 3.47a.75.75 0 0 0-1.06 1.06l1 1a.75.75 0 0 0 1.06-1.06l-1-1ZM18.53 3.47a.75.75 0 0 1 0 1.06l-1 1a.75.75 0 1 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 0Z'/>
    </svg>
  );
};

Products.propTypes = {
  altText: PropTypes.string
};

export default Products;
